import classNames from "classnames";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import Popup from "reactjs-popup";

import { useMainStore } from "@/contexts/Store";
import { User } from "@/stores/types/user-types";

import placeholderPlus from "../../../../images/table-image/icon/plus-black.svg";
import placeholderUser from "../../../../images/table-image/icon/user-placeholder.svg";
import { userColors } from "../../../constants";
import UsersCircle from "../../../table/shared/UsersCircle";

export type UserSelectForTaskProps = {
  notAssignees: User[];
  assigneesIDs: number[];
  taskModuleWorkspaceID: number;
  setAssigneeIDs: React.Dispatch<React.SetStateAction<number[]>>;
};

function UserSelectForTask({
  notAssignees,
  assigneesIDs,
  taskModuleWorkspaceID,
  setAssigneeIDs,
}: UserSelectForTaskProps) {
  // Import MobX stores
  const mainStore = useMainStore();

  // State
  const [showPopup, setShowPopup] = useState(false);

  // Variables
  const { task_id } = useParams<{ task_id: string }>();
  const taskID = Number(task_id);
  const triggerClasses = classNames({ active: showPopup });

  const renderTrigger = (
    <li className={triggerClasses}>
      <img src={placeholderUser} alt="placeholder-user" />
      <span className="select-assignee-user" data-testid="select-assignee-user">
        - Select -
      </span>
      <img src={placeholderPlus} alt="placeholder-user" />
    </li>
  );

  function addAssignee(id: number) {
    const newAssigneeIDs = [...assigneesIDs, id];
    setAssigneeIDs(newAssigneeIDs);
    setShowPopup(false);
    mainStore.comments.update(
      taskID,
      { assignees_ids: newAssigneeIDs },
      taskModuleWorkspaceID,
    );
  }

  return (
    <Popup
      position="bottom left"
      trigger={renderTrigger}
      open={showPopup}
      onOpen={() => setShowPopup(true)}
      onClose={() => setShowPopup(false)}
      keepTooltipInside
      nested
    >
      <div className="users-dropdown time-popup-wrap">
        {notAssignees.map((user) => (
          <div
            key={user.id}
            className="time-element assignee-user"
            data-testid="assignee-user"
            onClick={() => {
              addAssignee(user.id);
            }}
          >
            <UsersCircle
              key={user.id}
              user={user}
              additionalStyles={{
                background: userColors[user.icon_color_index],
              }}
              showFullName
            />
          </div>
        ))}
      </div>
    </Popup>
  );
}

export default UserSelectForTask;
